/**
 * Worksheets class
 * @private
 */
/* eslint-disable */
export class Worksheets extends Array {
}
